import { ContentSection } from '../../types';

export const bangkokMallsContent: {
  title: string;
  imageUrl: string;
  introduction: string;
  sections: ContentSection[];
} = {
  title: 'קניונים בבנגקוק – חוויית קניות לכל טעם וסגנון',
  imageUrl: '/images/thailand/bangkok-malls/bangkok-malls-wide.jpeg',
  introduction:
    'בנגקוק הינה גן עדן לחובבי הקניות, עם מגוון עצום של קניונים המציעים הכול – ממותגי יוקרה ועד שווקים מקורים עם מחירים לכל כיס. מצורפת סקירה אודות הקניונים הבולטים בעיר, כולל כמה פנינות נסתרות שלא כולם מכירים.',
  sections: [
    {
      title: 'הקניונים המרכזיים בבנגקוק',
      type: 'sub-headers',
      description:
        'הקניונים המרכזיים בבנגקוק מציעים מגוון חוויות קניה - מיוקרה ועד מציאות:',
      content: [
        {
          subtitle: 'ICONSIAM',
          text: "<strong>מיקום:</strong> גדת נהר הצ'או פראיה<br /><strong>מדוע ללכת?</strong> אחד הקניונים המפוארים ביותר באסיה, משלב מותגים בינלאומיים – יוקרתיים ורגילים עם חוויית שוק תאילנדי מסורתי, כולל מופעי מזרקות ומתחם אוכל מרהיב. בערבים, ישנם מופעים ברחבת הקניון על שפת הנהר.",
        },

        {
          subtitle: 'Siam Paragon',
          text: '<strong>מיקום:</strong> אזור סיאם<br /><strong>מדוע ללכת?</strong> מרכז הקניות היוקרתי ביותר בעיר, עם חנויות של מותגים כמו לואי ויטון, שאנל ופרדה. כולל גם מתחם קולנוע מפואר ואקווריום תת-ימי.',
        },
        {
          subtitle: 'Siam Center',
          text: '<strong>מיקום:</strong> צמוד ל - Siam Paragon<br /><strong>מדוע ללכת?</strong> קניון בוטיקי עם עיצוב מודרני, חנויות של מעצבים תאילנדים ואווירה צעירה וטרנדית. אם אתם מחפשים אופנה ייחודית שלא תמצאו בכל מקום – זה המקום.',
        },
        {
          subtitle: 'Siam Discovery',
          text: '<strong>מיקום:</strong> ליד Siam Center<br /><strong>מדוע ללכת?</strong> קניון עם קונספט חדשני שמשלב חנויות, גלריות אמנות, חוויות אינטראקטיביות וטכנולוגיות מתקדמות, כולל מותגי יוקרה וחנויות לייף-סטייל ייחודיות.',
        },
        {
          subtitle: 'CentralWorld',
          text: '<strong>מיקום:</strong> ליד BTS Chit Lom<br /><strong>מדוע ללכת?</strong> הקניון הגדול ביותר בבנגקוק, עם מבחר עצום של חנויות, בשני מפלסים של 7 קומות, מסעדות, מתחם בילוי ואירועים שנתיים, כגון חגיגות השנה החדשה.',
        },
        {
          subtitle: 'MBK Center',
          text: '<strong>מיקום:</strong> ליד BTS National Stadium<br /><strong>מדוע ללכת?</strong> גן עדן למציאות בזול, עם שפע של חנויות המוכרות בגדים, אלקטרוניקה, תכשיטים ומזכרות במחירים סיטונאיים.',
        },
        {
          subtitle: 'Terminal 21',
          text: '<strong>מיקום:</strong> ליד BTS Asok<br /><strong>מדוע ללכת?</strong> קונספט ייחודי של "מסע עולמי" – כל קומה מעוצבת כמו עיר אחרת (לונדון, טוקיו, רומא וכו\'), עם שילוב של חנויות מעצבים מקומיים ואוכל טעים.',
        },
        {
          subtitle: 'Emporium',
          text: '<strong>מיקום:</strong> ליד BTS Phrom Phong<br /><strong>מדוע ללכת?</strong> קניון יוקרתי עם מותגים בינלאומיים, מסעדות שף ומתחם גורמה עשיר. חלק מ"המשולש היוקרתי" יחד עם EmQuartier ו-Emsphere.',
        },
        {
          subtitle: 'EmQuartier',
          text: '<strong>מיקום:</strong> ליד Emporium (BTS Phrom Phong)<br /><strong>מדוע ללכת?</strong> קניון מודרני עם חנויות יוקרה, מסעדות עם נוף מדהים, גינת גג יפהפייה ואפילו מפל פנימי!',
        },
        {
          subtitle: 'Emsphere',
          text: '<strong>מיקום:</strong> ליד Emporium ו-EmQuartier<br /><strong>מדוע ללכת?</strong> הקניון החדש ביותר בבנגקוק (נפתח ב-2024) עם שילוב של מותגים יוקרתיים, חנויות קונספט חדשניות ומתחם הופעות ובידור.',
        },
        {
          subtitle: 'Platinum Fashion Mall',
          text: '<strong>מיקום:</strong> ליד CentralWorld<br /><strong>מדוע ללכת?</strong> גן עדן לנשים ונערות! חוויית קניות בסגנון שוק מקורה עם אלפי חנויות בגדים ואקססוריז במחירים סיטונאיים. מתאים במיוחד למי שמחפש אופנה זולה ואופנת רחוב טרנדית.',
        },
      ],
    },
    {
      title: 'Platinum Fashion Mall',
      content: '',
      type: 'image',
      imageUrl: '/images/thailand/bangkok-malls/bangkok-malls-article-1.jpg',
    },
    {
      title: 'קניונים פחות מוכרים אך שווים ביקור',
      type: 'sub-headers',
      description:
        'מלבד הקניונים המפורסמים, ישנם גם קניונים פחות מוכרים לתיירים אך שווים ביקור:',
      content: [
        {
          subtitle: 'Central Pinklao',
          text: '<strong>מיקום:</strong> אזור Pinklao (מערב בנגקוק)<br /><strong>מדוע ללכת?</strong> קניון מקומי פחות מתוייר עם חנויות אופנה, מסעדות מצוינות וקולנוע גדול, קרוב לאזור הקוואסאן ומתאים למי שרוצה לברוח מהמולת התיירים במקום.',
        },
        {
          subtitle: 'Seacon Square Srinagarindra',
          text: "<strong>מיקום:</strong> אזור Srinagarindra (מזרח בנגקוק)<br /><strong>מדוע ללכת?</strong> אחד הקניונים הגדולים בעיר עם אווירה מקומית, מתחם משחקים ענק לילדים ושוק וינטג' מעניין בשם Talad Rot Fai הצמוד אליו.",
        },
        {
          subtitle: 'The Mall Bangkapi',
          text: '<strong>מיקום:</strong> אזור Bangkapi (צפון-מזרח בנגקוק)<br /><strong>מדוע ללכת?</strong> חוויית קניות מקומית עם מחירים נוחים, מגוון חנויות, פארק מים קטן ואזור אוכל אותנטי.',
        },
        {
          subtitle: 'Bangkok Fashion Outlet',
          text: '<strong>מיקום:</strong> אזור סילום<br /><strong>מדוע ללכת?</strong> המקום האידיאלי למציאת מותגים בינלאומיים בהנחות גדולות – מייקל קורס, אדידס, נייקי ועוד במחירים מופחתים.',
        },
        {
          subtitle: 'Gateway Ekamai',
          text: '<strong>מיקום:</strong> ליד BTS Ekkamai<br /><strong>מדוע ללכת?</strong> קניון בסגנון יפני, עם חנויות, מסעדות ודוכנים מעוצבים בסגנון יפן. מתאים במיוחד למי שאוהב תרבות ואוכל יפני.',
        },
        {
          subtitle: 'Union Mall',
          text: '<strong>מיקום:</strong> ליד MRT Phahon Yothin<br /><strong>מדוע ללכת?</strong> קניון בסגנון מקומי עם חנויות אופנה צעירות במחירים משתלמים, ללא ההמולה של MBK או Platinum.',
        },
        {
          subtitle: 'Mega Bangna',
          text: '<strong>מיקום:</strong> מחוץ לעיר, ליד Suvarnabhumi Airport<br /><strong>מדוע ללכת?</strong> אחד הקניונים הגדולים בתאילנד, עם חנויות רבות, מתחם איקאה ענק, קולנוע IMAX ואזורי בילוי לכל המשפחה.',
        },
        {
          subtitle: 'Central Village',
          text: '<strong>מיקום:</strong> ליד שדה התעופה סוברנבומי<br /><strong>מדוע ללכת?</strong> אאוטלט פרימיום עם הנחות גדולות על מותגים בינלאומיים כמו Coach, Adidas, Michael Kors ועוד.',
        },
        {
          subtitle: 'Future Park Rangsit',
          text: '<strong>מיקום:</strong> צפון בנגקוק<br /><strong>מדוע ללכת?</strong> קניון ענק עם כל מה שצריך – חנויות אופנה, מסעדות, מתחם אוכל רחוב ומתחם בילוי למשפחות.',
        },
      ],
    },
    {
      title: 'טיפים לשופינג מוצלח בבנגקוק',
      type: 'sub-headers',
      description:
        'כדי למקסם את חוויית הקניות שלכם בבנגקוק, הנה כמה טיפים שימושיים:',
      content: [
        {
          subtitle: 'בחירת הקניון המתאים',
          text: 'בחר את הקניון המתאים לך – אם מחפשים יוקרה, לכו ל-ICONSIAM או Siam Paragon, אם מחפשים מותגים פחות יוקרתיים אך אלו המוכרים לנו, Central World הינו הכתובת אך במידה ומחפשים מציאות, עדיף ה - MBK או Seacon Square.',
        },
        {
          subtitle: 'ניצול הנחות',
          text: 'נצלו את ההנחות – חפשו מבצעי סוף עונה וקופונים (חלק מהחנויות מחלקות קופוני תיירים בהצגת דרכון).',
        },
        {
          subtitle: 'תכנון זמן',
          text: 'תכננו את הזמן שלכם – הקניונים בבנגקוק גדולים מאוד ולכן, כדאי להקדיש לפחות חצי יום לכל קניון משמעותי.',
        },
        {
          subtitle: 'הימנעות מעומסים',
          text: 'הימנעו משעות העומס – בשעות הערב וסופי השבוע הקניונים עמוסים מאוד, נסו להגיע בבקרים או בימי חול.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      type: 'text',
      content:
        'בנגקוק היא לא רק עיר של מקדשים ושווקים – חוויית הקניונים כאן היא חלק בלתי נפרד מהתרבות המודרנית של העיר. אין זה משנה אם מחפשים מותגים יוקרתיים, אופנה מקומית או מציאות בזול – כל אחד יכול למצוא כאן את הקניון שמתאים לו!',
      isBold: true,
    },
    {
      title: 'המלצת הזהב',
      type: 'text',
      content:
        'במידה ויש לכם יום עד מקסימום יומיים עבור קניות, נמליץ לכם ללכת ל"משולש" הכולל את Central World, בו תמצאו את כל הקשור למותגים רגילים - מוכרים ולא מוכרים, את Platinum Fashion Mall, בו תמצאו כל שתחפשו בעיקר עבור נשים ונערות אך גם עבור גברים וילדים ואת Big C Supercenter, בו תמצאו את כל הקשור למוצרי פארם, ממתקים, אוכל ועוד.',
    },
  ],
};
